import React from "react";
import Constants from "../../constants/Constants";
import { Link } from "@reach/router";
const FavLibNav = ({ modelName }) => {
  return (
    <ul
      className="scroll_panel"
      id="tabs"
      style={{ borderTop: "1px solid #353535" }}
    >
      <li>
        <Link
          to={`${Constants.MA}favorites`}
          className={
            modelName === "favorites" ? "item_link active" : "item_link"
          }
        >
          {modelName === "favorites" || modelName === "library"
            ? "Favs"
            : "Videos"}
        </Link>
      </li>
      {modelName === "favorites" || modelName === "library" ? (
        <li>
          <Link
            to={`${Constants.MA}library`}
            className={
              modelName === "library" ? "item_link active" : "item_link"
            }
          >
            My Library
          </Link>
        </li>
      ) : null}

      {/* <li>
            <a href="#tab2" className="item_link">
              Pics
            </a>
          </li> */}
    </ul>
  );
};

export default FavLibNav;
